<template>
  <rui-overlay class="rui-image-viewer">
    <div class="rui-image-viewer__close">
      <!--
        Closes the viewer
        @event close
      -->
      <rui-button icon="rui:x-square"
                  :title="$t('rui.generic.close')"
                  size="large"
                  @click="$emit('close')" />
    </div>

    <div class="rui-image-viewer__image">
      <img :src="currentURL" :alt="$t('rui.image_viewer.a_picture')">
    </div>

    <div v-if="list.length > 1" class="rui-image-viewer__controls">
      <rui-toolbar>
        <rui-button icon="rui:skip-back"
                    size="large"
                    :disabled="!hasButtons"
                    :title="$t('rui.image-viewer.previous')"
                    @click="changePicture(-1)" />

        <rui-button icon="rui:skip-forward"
                    size="large"
                    :disabled="!hasButtons"
                    :title="$t('rui.image-viewer.next')"
                    @click="changePicture(1)" />
      </rui-toolbar>
    </div>
  </rui-overlay>
</template>
<script>
import RuiButton from '../../Button/Button.vue'
import RuiToolbar from '../../Toolbar/Toolbar.vue'
import RuiOverlay from '../../Utils/Overlay/Overlay.vue'

/**
 * Displays pictures in full screen with the ability to navigate in lists
 *
 * @noPlayground Component needs configuration
 */
export default {
  name: 'RuiImageViewer',
  emits: [
    'close',
  ],
  components: { RuiOverlay, RuiToolbar, RuiButton },
  props: {
    /** List of URLs */
    list: { required: false, type: Array, default: () => [] },
    /** Current URL to display */
    preselected: { required: true, type: String },
  },
  data () {
    return {
      currentURL: this.$props.preselected,
    }
  },
  computed: {
    hasButtons () { return this.$props.list.length > 1 },
  },
  methods: {
    changePicture (shiftIndex) {
      const currentIndex = this.$props.list.findIndex(url => url === this.currentURL)
      const lastIndex = this.$props.list.length - 1
      let nextIndex = currentIndex + shiftIndex

      if (nextIndex < 0) nextIndex = lastIndex
      else if (nextIndex > lastIndex) nextIndex = 0

      this.currentURL = this.$props.list[nextIndex]
    },
  },
}
</script>
